import { IconMail, IconPhone, IconWhatsapp } from 'components/Icons';
import { Link } from 'components/Link';
import React from 'react';
import styles from './AddressCard.module.css';

export const AddressCard = () => (
  <div className={styles.container}>
    <h2>Groundwork</h2>
    <p>
      <strong>Postadres</strong>
      <br />
      Plesmanstraat 31
      <br />
      3905 KZ Veenendaal
    </p>
    <br />
    <p>
      <strong>Bezoekadres</strong>
      <br />
      Plesmanstraat 29-33
      <br />
      3905 KZ Veenendaal
    </p>
    <p className={styles.links}>
      <LinkWithIcon icon="mail" url="mailto:info@groundwork.nl">
        info@groundwork.nl
      </LinkWithIcon>
      <LinkWithIcon icon="tel" url="tel:0853034220">
        085 303 4220
      </LinkWithIcon>
    </p>
    <p>
      Telefonisch bereikbaar op maandag, dinsdag en woensdag tussen 9.00 - 15.00
      uur
    </p>
    <br />
    <p>Binnen 3 werkdagen kan je van ons een reactie op je mail verwachten</p>
  </div>
);

const LinkWithIcon = ({ url, icon, children }) => {
  const icons = {
    mail: IconMail,
    tel: IconPhone,
    whapp: IconWhatsapp,
  };

  const Icon = icons[icon] || IconMail;

  return (
    <Link className={styles.linkWithIcon} url={url}>
      <span className={styles.linkWithIconInner}>
        <span className={styles.iconContainer}>
          <Icon />
        </span>
        <span>{children}</span>
      </span>
    </Link>
  );
};
